import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HeaderModel } from 'src/app/_component/header/header.model';

@Injectable({
  providedIn: 'any',
})
export class HeaderService {
  private headerInit: BehaviorSubject<HeaderModel> = new BehaviorSubject<HeaderModel>(
    new HeaderModel()
  );

  constructor() {}

  /**
   * Ustawia headerInit.
   * Radzę, zwrówcić uwage na umiejscowienie tej metody
   * pozwoli to uniknąć części błędów.
   * @param header headerInit
   */
  setHeaderInit(header: HeaderModel): void {
    this.headerInit.next(header);
  }

  /**
   * @returns  Observable<HeaderModel>, gdzie HeaderModel to headerInit.
   */
  getHeaderInit(): Observable<HeaderModel> {
    return this.headerInit.asObservable();
  }
}
